import lij_IT from "./locales/lij-IT.json.gz"
import lv_LV from "./locales/lv-LV.json.gz"
import km_KH from "./locales/km-KH.json.gz"
import pa_PK from "./locales/pa-PK.json.gz"
import pl_PL from "./locales/pl-PL.json.gz"
import hu_HU from "./locales/hu-HU.json.gz"
import mn_MN from "./locales/mn-MN.json.gz"
import es_ES from "./locales/es-ES.json.gz"
import nb_NO from "./locales/nb-NO.json.gz"
import es_CL from "./locales/es-CL.json.gz"
import zh_CN from "./locales/zh-CN.json.gz"
import da_DK from "./locales/da-DK.json.gz"
import bal_PK from "./locales/bal-PK.json.gz"
import hr_HR from "./locales/hr-HR.json.gz"
import et_EE from "./locales/et-EE.json.gz"
import fr_CA from "./locales/fr-CA.json.gz"
import bg_BG from "./locales/bg-BG.json.gz"
import ro_RO from "./locales/ro-RO.json.gz"
import ar from "./locales/ar.json.gz"
import eu from "./locales/eu.json.gz"
import he_IL from "./locales/he-IL.json.gz"
import hi_IN from "./locales/hi-IN.json.gz"
import cs_CZ from "./locales/cs-CZ.json.gz"
import nn_NO from "./locales/nn-NO.json.gz"
import de_DE from "./locales/de-DE.json.gz"
import fi_FI from "./locales/fi-FI.json.gz"
import de_CH from "./locales/de-CH.json.gz"
import tr_TR from "./locales/tr-TR.json.gz"
import sl_SI from "./locales/sl-SI.json.gz"
import sr_Cyrl_RS from "./locales/sr-Cyrl-RS.json.gz"
import gl_ES from "./locales/gl-ES.json.gz"
import cy_GB from "./locales/cy-GB.json.gz"
import ru_RU from "./locales/ru-RU.json.gz"
import en_US from "./locales/en-US.json.gz"
import sv_SE from "./locales/sv-SE.json.gz"
import it_IT from "./locales/it-IT.json.gz"
import es_MX from "./locales/es-MX.json.gz"
import zh_TW from "./locales/zh-TW.json.gz"
import nl_NL from "./locales/nl-NL.json.gz"
import fr_FR from "./locales/fr-FR.json.gz"
import vi_VN from "./locales/vi-VN.json.gz"
import tl_PH from "./locales/tl-PH.json.gz"
import de_AT from "./locales/de-AT.json.gz"
import brh_PK from "./locales/brh-PK.json.gz"
import is_IS from "./locales/is-IS.json.gz"
import ca_AD from "./locales/ca-AD.json.gz"
import en_GB from "./locales/en-GB.json.gz"
import id_ID from "./locales/id-ID.json.gz"
import pt_BR from "./locales/pt-BR.json.gz"
import ja_JP from "./locales/ja-JP.json.gz"
import la from "./locales/la.json.gz"
import uk_UA from "./locales/uk-UA.json.gz"
import hy_AM from "./locales/hy-AM.json.gz"
import sr_Latn_RS from "./locales/sr-Latn-RS.json.gz"
import sk_SK from "./locales/sk-SK.json.gz"
import ms_MY from "./locales/ms-MY.json.gz"
import el_GR from "./locales/el-GR.json.gz"
import th_TH from "./locales/th-TH.json.gz"
import pt_PT from "./locales/pt-PT.json.gz"
import af_ZA from "./locales/af-ZA.json.gz"
import lt_LT from "./locales/lt-LT.json.gz"
import fa_IR from "./locales/fa-IR.json.gz"
import ko_KR from "./locales/ko-KR.json.gz"

export const locales = {
    "lij-IT": lij_IT,
    "lv-LV": lv_LV,
    "km-KH": km_KH,
    "pa-PK": pa_PK,
    "pl-PL": pl_PL,
    "hu-HU": hu_HU,
    "mn-MN": mn_MN,
    "es-ES": es_ES,
    "nb-NO": nb_NO,
    "es-CL": es_CL,
    "zh-CN": zh_CN,
    "da-DK": da_DK,
    "bal-PK": bal_PK,
    "hr-HR": hr_HR,
    "et-EE": et_EE,
    "fr-CA": fr_CA,
    "bg-BG": bg_BG,
    "ro-RO": ro_RO,
    "ar": ar,
    "eu": eu,
    "he-IL": he_IL,
    "hi-IN": hi_IN,
    "cs-CZ": cs_CZ,
    "nn-NO": nn_NO,
    "de-DE": de_DE,
    "fi-FI": fi_FI,
    "de-CH": de_CH,
    "tr-TR": tr_TR,
    "sl-SI": sl_SI,
    "sr-Cyrl-RS": sr_Cyrl_RS,
    "gl-ES": gl_ES,
    "cy-GB": cy_GB,
    "ru-RU": ru_RU,
    "en-US": en_US,
    "sv-SE": sv_SE,
    "it-IT": it_IT,
    "es-MX": es_MX,
    "zh-TW": zh_TW,
    "nl-NL": nl_NL,
    "fr-FR": fr_FR,
    "vi-VN": vi_VN,
    "tl-PH": tl_PH,
    "de-AT": de_AT,
    "brh-PK": brh_PK,
    "is-IS": is_IS,
    "ca-AD": ca_AD,
    "en-GB": en_GB,
    "id-ID": id_ID,
    "pt-BR": pt_BR,
    "ja-JP": ja_JP,
    "la": la,
    "uk-UA": uk_UA,
    "hy-AM": hy_AM,
    "sr-Latn-RS": sr_Latn_RS,
    "sk-SK": sk_SK,
    "ms-MY": ms_MY,
    "el-GR": el_GR,
    "th-TH": th_TH,
    "pt-PT": pt_PT,
    "af-ZA": af_ZA,
    "lt-LT": lt_LT,
    "fa-IR": fa_IR,
    "ko-KR": ko_KR,}